import Icon from '../../components/Icon.vue'

Icon.register({
  'regular/grin-beam-sweat': {
    width: 496,
    height: 512,
    paths: [
      {
        d: 'M440 160C469.5 160 493.3 133.7 493.3 101.3 493.3 76.3 461.6 25.8 447.1 4 443.5-1.3 436.4-1.3 432.9 4 418.4 25.8 386.7 76.3 386.7 101.3 386.7 133.7 410.5 160 440 160zM248 400C299.9 400 363.3 367.1 371.3 320 373 310.1 363.6 301.5 353.6 304.7 327.7 313 289.2 317.8 248 317.8S168.4 313 142.4 304.7C132.6 301.6 123 310 124.7 320 132.7 367.1 196.1 400 248 400zM378.3 231.7C381.9 230.6 384.3 227.2 384 223.4 380.7 181.3 351.8 152 328 152S275.3 181.3 272 223.4C271.7 227.1 274.1 230.6 277.7 231.7 281.2 232.8 285.1 231.2 287 228L296.5 211C304.2 197.3 315.7 189.4 328 189.4S351.8 197.3 359.5 211L369 228C371.1 231.6 375.2 232.6 378.3 231.7zM483.6 178.8C459 194.5 437.6 191.7 437.2 191.7 444.1 211.9 448 233.5 448 256 448 366.3 358.3 456 248 456S48 366.3 48 256 137.7 56 248 56C287.8 56 324.8 67.8 356 87.9 357.7 78.4 362.3 63.8 373.2 42.2 336.4 20.6 293.7 8 248 8 111 8 0 119 0 256S111 504 248 504 496 393 496 256C496 229 491.6 203.1 483.6 178.8zM168 189.4C180.3 189.4 191.8 197.3 199.5 211L209 228C211.1 231.7 215.2 232.7 218.3 231.7 221.9 230.6 224.3 227.2 224 223.4 220.7 181.3 191.8 152 168 152S115.3 181.3 112 223.4C111.7 227.1 114.1 230.6 117.7 231.7 121.2 232.8 125.1 231.2 127 228L136.5 211C144.2 197.2 155.7 189.4 168 189.4z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/regular/grin-beam-sweat.js
// module id = BdrT
// module chunks = 144